import { Product } from '@/api/ProductApi';
import { Attachment, UUID } from './types';
import { Attribute } from '@/api/AttributeApi';
import { AttributeValue } from '@/api/AttributeValueApi';
import { ProductType } from '@/api/ProductTypeApi';
import { ShippingMethod } from '@/api/ShippingMethodApi';
import { ShippingPriority } from '@/api/ShippingPrioritiesApi';

export enum CreatorSearchParams {
	ORDER_ITEM = 'orderItem',
	OFFER_ITEM = 'offerItem',
	COPY = 'copy',
}

export type CreatorAttributeValue = AttributeValue & {
	disabled: boolean;
};

export type CreatorAttribute = Attribute & {
	attributeValues: AttributeValue[];
	filteredValues: CreatorAttributeValue[];
};

export enum CreatorStep {
	ATTRIBUTES = 'attributes',
	SUMMARY = 'summary',
}

export type SourceItemData = {
	id: UUID | null;
	product?: Product;
	quantity: number;
	deliveryDate: string;
	comment: string;
	shippingMethod: ShippingMethod | null;
	shippingPriority: ShippingPriority | null;
	attachments: Attachment[];
};

export interface CreatorState {
	productType: ProductType | null;
	matchedProduct: Product | null;
	availableProducts: Product[];
	attributesOrder: UUID[];
	selectedValues: Record<UUID, AttributeValue | null>;
	availableAttributes: CreatorAttribute[];
	sourceItemData: SourceItemData;
	options: CreatorOptions;
}

export enum CreatorSource {
	ORDER = 'order',
	OFFER = 'offer',
}

export interface CreatorOptions {
	step: CreatorStep;
	source: CreatorSource;
}
